/* eslint-disable react/prop-types */
/* eslint-disable react/no-multi-comp */
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Link from 'components/link';
import ContentWrapper from 'components/content-wrapper';
import HousingProjectBlockHeader from 'components/housing-project-block-header';
import Slider from 'react-slick';
import HousingProjectListWithIconItem from './housing-project-list-with-icons-item';

const HousingProjectListWithIconsBlock = ({
  title,
  link,
  description,
  items,
  theme,
  id
}) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slider = useRef();

  function SampleNextArrow(props) {
    const { onClick } = props;
    if (!onClick) setCurrentSlide(props.slideCount - 1);
    return (
      <button
        disabled={!onClick}
        aria-label="Neste"
        onClick={onClick}
        className="housing-project-list-with-icons-block__button-next"
      />
    );
  }

  function SamplePrevArrow(props) {
    const { onClick } = props;
    return (
      <button
        disabled={!onClick}
        aria-label="Forrige"
        onClick={onClick}
        className="housing-project-list-with-icons-block__button-prev"
      />
    );
  }

  const settings = {
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3.75,
    slidesToScroll: 1,
    fade: false,
    swipeToSlide: true,
    afterChange: current => setCurrentSlide(Math.round(current)),
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2.25
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.25
        }
      }
    ]
  };

  return (
    <div
      className={cn('housing-project-list-with-icons-block', {
        [`housing-project-list-with-icons-block--${theme}`]: theme,
        [`housing-project-list-with-icons-block housing-project-list-with-icons-block--${id}`]: id
      })}
    >
      <ContentWrapper>
        <HousingProjectBlockHeader
          title={title}
          link={link ? link : null}
          description={description ? description : null}
          theme={theme}
        />
        {items &&
          items.length > 0 &&
          (items.length > 4 ? (
            <>
              <Slider
                ref={slider}
                {...settings}
                className="housing-project-list-with-icons-block__slider"
              >
                {items.map((item, index) => {
                  let myIndex = index + 1;
                  return (
                    <div
                      // eslint-disable-next-line react/no-array-index-key
                      key={index}
                      className={cn(
                        'housing-project-list-with-icons-block__item',
                        {
                          [`housing-project-list-block__item housing-project-list-with-icons-block__item--${myIndex}`]: items
                        }
                      )}
                    >
                      <HousingProjectListWithIconItem {...item} />
                    </div>
                  );
                })}
              </Slider>
              <div className="housing-project-list-with-icons-block__counter">
                {currentSlide + 1 < 10 && 0}
                {currentSlide + 1}
                <span className="housing-project-list-with-icons-block__counter-total">
                  /{items.length < 10 && 0}
                  {items.length}
                </span>
              </div>
            </>
          ) : (
            <ul
              className={cn('housing-project-list-with-icons-block__items', {
                [`housing-project-list-block__items housing-project-list-with-icons-block__items--${items.length}`]: items
              })}
            >
              {items.map((item, index) => {
                let myIndex = index + 1;
                return (
                  <li
                    className={cn(
                      'housing-project-list-with-icons-block__item',
                      {
                        [`housing-project-list-block__item housing-project-list-with-icons-block__item--${myIndex}`]: items
                      }
                    )}
                    key={item.title}
                  >
                    <HousingProjectListWithIconItem {...item} />
                  </li>
                );
              })}
            </ul>
          ))}
      </ContentWrapper>
    </div>
  );
};

HousingProjectListWithIconsBlock.propTypes = {
  title: PropTypes.string,
  link: PropTypes.exact(Link.propTypes),
  description: PropTypes.string,
  theme: PropTypes.string,
  id: PropTypes.string,
  items: PropTypes.arrayOf(HousingProjectListWithIconItem.propTypes).isRequired
};

HousingProjectListWithIconsBlock.propTypesMeta = {
  theme: 'exclude'
};

export default HousingProjectListWithIconsBlock;
